export const DEVICE_CODE = 'VodafoneSTB';
